export default "__VITE_ASSET__ZKE3Cnha__"